/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import { Component, HostListener, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

import { environment } from "../environments/environment";
import { SessionService } from "./platform/base/services/session.service";
import _ from "lodash";
declare let gtag: any; // グローバル変数gtagを解決(page側で定義)

/**
 * アプリケーション
 * @since 0.01
 */
@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
	private touch_delta = 0;

	/**
	 * @returns none
	 */
	constructor(protected session: SessionService, public router: Router, private route: ActivatedRoute, private title: Title, private meta: Meta) {}

	/**
	 * タッチタイミング
	 * @param event
	 */
	@HostListener("touchstart", ["$event"])
	public onTouchStart(event: any): void {
		if (event.touches.length >= 2) {
			event.preventDefault();
		}
	}

	/**
	 * タッチタイミング
	 * @param event
	 */
	@HostListener("touchend", ["$event"])
	public onTouchEnd(event: any): void {
		const now: number = new Date().getTime();
		if (now - this.touch_delta < 350) {
			event.preventDefault();
		}
		this.touch_delta = now;
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.router.events
			.pipe(
				// SEO関連...
				filter((event) => event instanceof NavigationEnd)
			)
			.subscribe((event: any) => {
				const top_meta = environment.meta.top;
				this.setDescription(top_meta);
				this.sendPageView(event.url);

				this.route.queryParams.subscribe((params) => {
					if (params.token) {
						this.session.put({ token: params.token }, () => {});
					}
				});
			});
	}

	/**
	 * @returns none
	 */
	public setDescription(meta: { title: string; description: any[] }): void {
		this.title.setTitle(meta.title);
		meta.description.forEach((each_description) => {
			this.meta.updateTag(each_description);
		});
	}

	/**
	 * GAの読み込みをチェック
	 */
	private useGA(): boolean {
		return typeof gtag !== 'undefined';
	}

	/**
	 * ページトラッキング
	 * @param  {string} url URLのパス。スラッシュで始まる必要がある。
	 */
	public sendPageView(url: string): void {
		if (this.useGA()) {
			if (!url.startsWith("/")) {
				url = `/${url}`;
			}
			if (gtag && _.get(environment, "analytics.id") !== "G-*******-*") {
				gtag("config", environment.analytics.id, {
					page_path: url,
				});
			}
		}
	}

	/**
	 * イベントトラッキング
	 * @param  {string} eventCategory (e.g. 'Video')
	 * @param  {string} eventAction (e.g. 'play')
	 * @param  {string} eventLabel (e.g. 'play campaign CM')
	 */
	public sendEvent(eventName: string, eventCategory: string, eventAction: string, eventLabel: any): void {
		if (this.useGA()) {
			gtag("event", eventName, {
				event_category: eventCategory,
				event_action: eventAction,
				event_label: eventLabel,
			});
		}
	}
}
